import { useRef } from 'react';
import classes from '../ReportResult/ReportResult.module.css';
import NewRealPlayHeader from './NewRealPlayHeader';
import NewRealPlayLeftSection from './NewRealPlayLeftSection';
import NewRealPlayRightSection from './NewRealPlayRightSection';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';
import Transcription from '../ReportResult/Transcription';
import ModeLabel from '../Common/ModeLabel';
import RealPlayQualifiedLogic from './RealPlayQualified.logic';

const NewReviewQualifiedRoleplay = ({ isLoadingResponse }) => {
  const playerRef = useRef(null);
  const { self_assigned } = RealPlayQualifiedLogic();
  const {
    assignment_uuid,
    selectedScenario,
    assigned_by_user,
    assigned_to_user,
    persona_name: prospectName,
    persona_image,
  } = RealPlayRecordDataHelper();

  const handleSeek = (timestamp) => {
    const seconds = parseFloat(timestamp);
    const player = playerRef.current;
    if (player) {
      player.seekTo(seconds, 'seconds');
      player.getInternalPlayer()?.play?.();
    }
  };

  return (
    <div>
      <div className={classes.headerContainer}>
        <NewRealPlayHeader />
      </div>
      <div className={classes.contextInfoContainer}>
        <ModeLabel mode={self_assigned ? 'Practice' : 'Assesment'} />
      </div>
      <div className={classes.gridContainer} style={{ marginTop: 16 }}>
        <NewRealPlayLeftSection isLoadingResponse={isLoadingResponse} playerRef={playerRef} />
        <NewRealPlayRightSection isLoadingResponse={isLoadingResponse} handleSeek={handleSeek} />
      </div>
      <div className={classes.transcriptionContainer}>
        {/* Transcription*/}
        <Transcription
          assignment_uuid={assignment_uuid}
          scenario_uuid={selectedScenario?.uuid}
          response_uuid={selectedScenario?.response?.uuid}
          clientName={prospectName}
          userName={`${assigned_to_user?.first_name} ${assigned_to_user?.last_name}`}
          assigned_by_user={assigned_by_user}
          client_profile_pic={persona_image}
        />
      </div>
    </div>
  );
};

export default NewReviewQualifiedRoleplay;
